export default "__VITE_ASSET__D3ALsp16__"